module.exports = __webpack_public_path__ + "static/feelsbad-8aa440eb44b42f1a5a38159500bb0f3b.png";